import React from 'react';
import LockClosedFilledIcon from '@assets/icons/modal/alert1.svg';
import { BaseButton, BaseModal } from '@components';
import { ModalHeader as Header, ModalTopSection as TopSection } from '@routes/___shared___/styled.tsx';
import { AlertSection } from '@routes/auth/___shared___/styled.tsx';
import {
    SHARED_CONSENT_MODAL_CANCEL,
    SHARED_CONSENT_MODAL_CLOSE,
    SHARED_CONSENT_MODAL_CONFIRM,
    SHARED_CONSENT_MODAL_HEADER_DELETE,
    SHARED_CONSENT_MODAL_HEADER_INFO,
    SHARED_CONSENT_MODAL_MSG_DELETE,
    SHARED_CONSENT_MODAL_MSG_INFO,
    SHARED_CONSENT_MODAL_REQUEST_ID_LABEL,
    SHARED_CONSENT_MODAL_SUBMITTED_ON_LABEL,
} from '@routes/sidebar/settings/ui/consent-center-tab/consent-modal/constants.ts';
import { translateItem } from '@utils/translations.ts';

import { BaseButtonTitle, ModalButtonsWrapper as ButtonsWrapper, modalForceStyles } from '../styled.ts';

interface Props {
    open: boolean;
    closeIcon: React.ReactNode;
    setIsOpen: (isOpen: boolean) => void;
    onConfirmDelete: () => void;
    isSubmitOk: boolean;
    isLoading: boolean;
    submitDate: string;
    requestId: string;
}

const Modal: React.FC<Props> = ({
    open,
    closeIcon,
    setIsOpen,
    onConfirmDelete,
    isSubmitOk,
    isLoading,
    submitDate,
    requestId,
}) => {
    const HEADER_DELETE = translateItem(SHARED_CONSENT_MODAL_HEADER_DELETE);
    const HEADER_INFO = translateItem(SHARED_CONSENT_MODAL_HEADER_INFO);
    const MSG_DELETE = translateItem(SHARED_CONSENT_MODAL_MSG_DELETE);
    const MSG_INFO = translateItem(SHARED_CONSENT_MODAL_MSG_INFO);

    const handleSubmit = () => {
        onConfirmDelete();
    };

    return (
        <BaseModal
            closeIcon={closeIcon}
            open={open}
            title={
                <TopSection>
                    <LockClosedFilledIcon />
                    <Header>{isSubmitOk ? HEADER_INFO : HEADER_DELETE}</Header>
                </TopSection>
            }
            styles={{ mask: modalForceStyles.mask }}
            content={
                <>
                    <AlertSection>
                        {isSubmitOk ? (
                            <AlertSection>
                                <div>{MSG_INFO}</div>
                                <br />
                                <div>
                                    {translateItem(SHARED_CONSENT_MODAL_REQUEST_ID_LABEL)}: {requestId}
                                </div>
                                <br />
                                <div>
                                    {translateItem(SHARED_CONSENT_MODAL_SUBMITTED_ON_LABEL)}: {submitDate}
                                </div>
                            </AlertSection>
                        ) : (
                            MSG_DELETE
                        )}
                    </AlertSection>
                    <ButtonsWrapper>
                        {isSubmitOk ? (
                            <BaseButton $customType="primary" onClick={() => setIsOpen(false)}>
                                <BaseButtonTitle>{translateItem(SHARED_CONSENT_MODAL_CLOSE)}</BaseButtonTitle>
                            </BaseButton>
                        ) : (
                            <>
                                <BaseButton
                                    id={'confirm-del-btn'}
                                    loading={isLoading}
                                    $customType="outline"
                                    onClick={handleSubmit}
                                >
                                    <BaseButtonTitle>{translateItem(SHARED_CONSENT_MODAL_CONFIRM)}</BaseButtonTitle>
                                </BaseButton>
                                <BaseButton $customType="primary" onClick={() => setIsOpen(false)}>
                                    <BaseButtonTitle>{translateItem(SHARED_CONSENT_MODAL_CANCEL)}</BaseButtonTitle>
                                </BaseButton>
                            </>
                        )}
                    </ButtonsWrapper>
                </>
            }
            footer={null}
        />
    );
};

export default Modal;
